import { Converter } from '../types/converter';

export const electricFieldStrengthConverter: Converter = {
  id: 'electricFieldStrength',
  name: 'Electric Field Strength Converter',
  icon: 'Zap',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Volt/meter', symbol: 'V/m', factor: 1 },
    
    // SI prefixed units
    { name: 'Kilovolt/meter', symbol: 'kV/m', factor: 1000 },
    { name: 'Millivolt/meter', symbol: 'mV/m', factor: 0.001 },
    { name: 'Microvolt/meter', symbol: 'µV/m', factor: 1e-6 },
    
    // Common variants
    { name: 'Kilovolt/centimeter', symbol: 'kV/cm', factor: 100000 },
    { name: 'Volt/centimeter', symbol: 'V/cm', factor: 100 },
    { name: 'Kilovolt/inch', symbol: 'kV/in', factor: 39370.07874 },
    { name: 'Volt/inch', symbol: 'V/in', factor: 39.37007874 },
    { name: 'Volt/mil', symbol: 'V/mil', factor: 39370.07874 },
    
    // CGS units
    { name: 'Abvolt/centimeter', symbol: 'abV/cm', factor: 1e-6 },
    { name: 'Statvolt/centimeter', symbol: 'stV/cm', factor: 29979.2458 },
    { name: 'Statvolt/inch', symbol: 'stV/in', factor: 76146.88433 },
    
    // Force per charge
    { name: 'Newton/coulomb', symbol: 'N/C', factor: 1 }
  ]
};
